import { ACFMediaFragment } from "@/fragments";
import { gql } from "@apollo/client";

const CoverStoryOptionsQuery = gql`
  ${ACFMediaFragment}
  query GetCoverStoryOptions($language: String!) {
    coverStoryLandingPage: pageBy(uri: "/cover-story") {
      uri
    }
    coverStoryOptions: localizedOptionPage(slug: "cover-story", language: $language) {
      coverStoryOptions {
        coverStoryGridSize
        coverStoryListHeadline
        coverStoryListSubhead
        coverStoryListLabels {
          solvedPlural
          solvedSingular
          resume
          lost
          playMore
        }
        soundPopupOverride
        searchPlacholder
        incorrectGuess
        finalGuess
        coverStoryDetailOgImage {
          ...ACFMedia
        }
        howToModal {
          eyebrow
          headline
          ctaLabel
          stepOne {
            headline
            subhead
          }
          stepTwo {
            headline
            subhead
          }
          stepThree {
            headline
            subhead
          }
        }
        tileCount {
          plural
          singular
        }
        coverStoryEndScreenHeadline {
          singular
          plural
        }
        coverStoryEndScreenIncorrect {
          headline
          subhead
        }
        coverStoryEndScreenButtonLabels {
          shop
          share
          playMore
          copied
          cursorText
        }
        coverStoryEndScreenBanner {
          type
          largeBorder
          eyebrow
          headline
          subhead
          link {
            linkType
            externalLink
            sectionId
            page {
              node {
                uri
              }
            }
          }
        }
        coverStoryEndScreenTileText {
          tiles0 {
            subhead
          }
          tiles1 {
            subhead
          }
          tiles2Through4 {
            subhead
          }
          tiles5Through7 {
            subhead
          }
          tiles8Through10 {
            subhead
          }
        }
        ariaLabels {
          playGame
          showInstructions
          clearInput
          submitInput
        }
      }
    }
  }
`;

export default CoverStoryOptionsQuery;